(function () {

  'use strict';

  eclipseApp.factory('prepaidPlanInfoService', function() {

    var airTimePlanFee = null,
      airTimePlanTitle = null,
      airTimePlanSoc = null,
      airTimePlanFeatures = null,
      airTimePlanBillingCycleDate = null,
      addonsDetails = null,
      autoSubscriptionInfo = null;

    function setAirTimePlanFee(data) {
      airTimePlanFee = data;
    }

    function getAirTimePlanFee() {
      return airTimePlanFee;
    }

    function setAirTimePlanTitle(data) {
      airTimePlanTitle = data;
    }

    function getAirTimePlanTitle() {
      return airTimePlanTitle;
    }

    function setAirTimePlanSoc(data) {
      airTimePlanSoc = data;
    }

    function getAirTimePlanSoc() {
      return airTimePlanSoc;
    }

    function setAirTimePlanFeatures(data) {
      airTimePlanFeatures = data;
    }

    function getAirTimePlanFeatures() {
      return airTimePlanFeatures;
    }

    function setAirTimePlanBillingCycleDate(data) {
      airTimePlanBillingCycleDate = data;
    }

    function getAirTimePlanBillingCycleDate() {
      return airTimePlanBillingCycleDate;
    }

    function setAddonsDetails(data) {
      addonsDetails = data;
    }

    function getAddonsDetails() {
      return addonsDetails;
    }

    function setAutoSubscriptionInfo(data) {
      autoSubscriptionInfo = data;
    }

    function getAutoSubscriptionInfo() {
      return autoSubscriptionInfo;
    }

    return {
      setAirTimePlanFee: setAirTimePlanFee,
      getAirTimePlanFee: getAirTimePlanFee,
      setAirTimePlanTitle: setAirTimePlanTitle,
      getAirTimePlanTitle: getAirTimePlanTitle,
      setAirTimePlanSoc: setAirTimePlanSoc,
      getAirTimePlanSoc: getAirTimePlanSoc,
      setAirTimePlanFeatures: setAirTimePlanFeatures,
      getAirTimePlanFeatures: getAirTimePlanFeatures,
      setAirTimePlanBillingCycleDate: setAirTimePlanBillingCycleDate,
      getAirTimePlanBillingCycleDate: getAirTimePlanBillingCycleDate,
      setAddonsDetails: setAddonsDetails,
      getAddonsDetails: getAddonsDetails,
      setAutoSubscriptionInfo: setAutoSubscriptionInfo,
      getAutoSubscriptionInfo: getAutoSubscriptionInfo
    };

  });

})();
